import "./App.css";
import Jamboard from "./Jamboard";

function App() {
  return (
    <>
      <Jamboard />
    </>
  );
}

export default App;
